import Input from "../helper/FieldInput";
import { Controller } from "react-hook-form";
import handleErrorMsg from "../helper/handleErrorMsg";
import useTranslation from "next-translate/useTranslation";
import { FormControl, InputAdornment } from "@mui/material";
import CustomImage from "@components/CustomImage";

function isEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
}

export default function EmailInputController({
  name,
  control,
  rules,
  defaultValue = "",
  ...otherProps
}) {
  const { t } = useTranslation("common-locale");

  return (
    <FormControl fullWidth>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({
          field: { value, ...otherRenderProps },
          fieldState: { error },
        }) => {
          return (
            <div>
              <Input
                helperText={handleErrorMsg(error, t)}
                error={Boolean(error)}
                value={value ?? ""}
                InputProps={{
                  endAdornment: isEmail(value) ? (
                    <InputAdornment position="end">
                      <CustomImage
                        width={25}
                        height={25}
                        className="w-7"
                        alt="valid-email"
                        src="/images/global/complete.png"
                      />
                    </InputAdornment>
                  ) : null,
                }}
                {...otherProps}
                {...otherRenderProps}
              />
            </div>
          );
        }}
        defaultValue={defaultValue}
      />
    </FormControl>
  );
}
